<template>
    <v-dialog
        :value="isOpen"
        scrollable
        :max-width="'600px'"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @keydown.enter="onSave"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Po zatwierdzeniu kalkulacji następujące puste montaże zostaną usunięte:
                    </template>
                </h1>
            </v-card-title>
            <v-card-text>
                <v-list dense>
                    <v-list-item
                        v-for="(emptyImposition, index) in emptyImpositions"
                        :key="index"
                    >
                        <v-list-item-title>{{ emptyImposition }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Potwierdź"
                    @click="onSave"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>


export default {
    name: 'CalculationConfirmRemoveEmptyImpositionsDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        calculationConfirmRemoveEmptyImpositionsData: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            calculationConfirmRemoveEmptyImpositions: [],
        }
    },
    computed: {
        emptyImpositions() {
            const emptyImpositions = []

            this.calculationConfirmRemoveEmptyImpositions.forEach((calculationConfirmRemoveEmptyImposition, index) => {
                
                if (calculationConfirmRemoveEmptyImposition.calculationProductComponentIds.length == 0) {
                    const impositionIndex = index + 1

                    emptyImpositions.push('Montaż ' + impositionIndex)
                    
                }
            })

            return emptyImpositions
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.calculationConfirmRemoveEmptyImpositions = this.calculationConfirmRemoveEmptyImpositionsData
            } else {
                setTimeout(() => {
                    this.calculationConfirmRemoveEmptyImpositions = []
                }, 500)
            }
        },
    },
    methods: {
        onSave() {
            this.$emit('on-save')
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>